/* eslint-disable @typescript-eslint/consistent-type-imports */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/unbound-method */
import { CommonModule } from '@angular/common';
import { map, type Observable } from 'rxjs';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import {
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { ActivatedRoute, Router } from '@angular/router';
import { GsIconListComponent } from '../../shared/components/gs-icon-list/gs-icon-list.component';
import { GSIconListBulletModel, GSIconListModel } from '../../shared/components/gs-icon-list/gs-icon-list.model';
import { StorageEnum } from '../../shared/enums/storage.enum';
import { Component, OnInit } from '@angular/core';

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';

// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../shared/services/util.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../../shared/services/storage.service';
import { CmsService } from '../../shared/services/cms.service';
import { AuthService } from '../../shared/services/auth.service';
import { CreatePassword } from '../../shared/models/create-passord';
import { Nav } from '../../shared/enums/nav.enum';
import { ErrorService } from '../../shared/services/error.service';
import { EmailFormComponent } from '../../shared/components/email-form/email-form.component';
import { emailValidator } from '../../shared/validators/email.validator';
import { RegisterAccountCredentials } from '../../shared/models/register-account-credentials';
import { NotificationComponent } from '../../shared/components/notification/notification.component';
import { NotificationsService } from '../../shared/services/notifications.service';
import { NotificationType } from '../../shared/enums/notificationtype.enum';

@Component({
  selector: 'app-register-account',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GsIconListComponent,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatCheckboxModule,
    EmailFormComponent,
    NotificationComponent,
  ],
  templateUrl: './register-account.component.html',
  styleUrl: './register-account.component.scss',
})
export class RegisterAccountComponent implements OnInit {
  pageLabels$!: Observable<any>;
  registerAccountForm!: FormGroup;
  apiErrors: any[] = [];
  apiError: string = '';
  genericError: any;
  isHover = false;
  isFocus = false;
  passwordVisible = false;
  confirmPasswordVisible = false;
  formErrorMessage: string = '';
  hasOneSpecialCharacter = false;
  hasOneNumber = false;
  hasLessthanSevenChar = false;
  charNotAllowed = false;
  hasNumberLettersUnderscore = false;
  userNamehasLessthanSevenChar = false;
  userNamehasSpaces = false;
  passwordSpecialCharacterText = '(can\'t be ()+=-[]\\;,./{}|":<>`~)';
  passwordAriaLabelText = `password requirements must have at least one number
  at least one special character and cannnot be left parentheseis right parenthesis
  plus sign equal sign minus sign open brace close brace
  back slash semi colon comma period forward slash open bracket close bracket
  pipe perenthesis colon less than angle greater than angle back tick tilde and at least 7-12 characters long`;

  createPasswordModel!: CreatePassword;
  hasEmail: boolean = false;
  emailFormData: any = {};
  accountNumber: string = '';
  customerClass: string = '';
  pageName = 'Register Account';

  constructor(
    private readonly cms: CmsService,
    private readonly auth: AuthService,
    private readonly formBuilder: FormBuilder,
    // eslint-disable-next-line @typescript-eslint/prefer-readonly
    private router: Router,
    private readonly utils: UtilService,
    private readonly storage: StorageService,
    private readonly route: ActivatedRoute,
    private readonly error: ErrorService,
    private readonly fb: FormBuilder,
    private readonly notifi: NotificationsService,
  ) {}

  ngOnInit(): void {
    this.pageLabels$ = this.cms.getContent('forgot-username-password', 'Forgot').pipe(
      map((data: any) => {
        const unmappedListData = data.bulletList.value.data;
        const listData = new GSIconListModel();
        listData.Header = unmappedListData.header;
        listData.Subheader = unmappedListData.subheader;

        const bulletList: GSIconListBulletModel[] = [];
        unmappedListData?.bulletList?.forEach((bullet: any) => {
          const bulletObj = new GSIconListBulletModel();
          bulletObj.BulletText = bullet.bullet.bulletText;
          bulletObj.BulletTitle = bullet.bullet.bulletTitle;
          bulletObj.IconPath = bullet.bullet.iconPath;
          bulletObj.IconAltText = bullet.bullet.iconAltText;
          bulletObj.ShowBullet = bullet.bullet.showBullet;

          bulletList.push(bulletObj);
        });

        listData.BulletList = bulletList;

        const newDataObj = JSON.parse(JSON.stringify(data));
        newDataObj.accountBenefitsList = listData;
        return newDataObj;
      }),
    );

    this.setupEmailData();
    this.getAccountNumberAndCustomerClass();

    this.registerAccountForm = this.formBuilder.group({
      username: [
        '',
        [Validators.required, Validators.maxLength(16), Validators.minLength(7), this.validateUsername.bind(this)],
      ],
      password: [
        '',
        [Validators.required, Validators.maxLength(12), Validators.minLength(7), this.validatePassword.bind(this)],
      ],
      confirmPassword: [
        '',
        [
          Validators.required,
          Validators.maxLength(12),
          Validators.minLength(7),
          this.validateConfirmPassword.bind(this),
        ],
      ],
      termsConditionsChkbox: [false, [Validators.required]],
    });
    this.utils.hideSpinner();
  }

  setupEmailData(): void {
    this.emailFormData.showConfirmEmail = true;
    this.emailFormData.formGroup = this.fb.group({
      email: ['', [Validators.required, emailValidator()]],
      emailConfirm: ['', [Validators.required, emailValidator()]],
    });
  }

  get username(): FormControl {
    return this.registerAccountForm.get('username') as FormControl;
  }

  get password(): FormControl {
    return this.registerAccountForm.get('password') as FormControl;
  }

  get confirmPassword(): FormControl {
    return this.registerAccountForm.get('confirmPassword') as FormControl;
  }

  resetButtonState(): void {
    // New method
    this.isHover = false;
    this.isFocus = false;
  }

  validateUsername(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    // allows letters, numbers but not just numbers
    const usernamePattern = /^(?!^\d+$)[a-zA-Z0-9]+$/;
    const usernamePatternNoSpaces = /^[\S]*$/;

    if (value.length < 7) {
      this.userNamehasLessthanSevenChar = true;
    } else {
      this.userNamehasLessthanSevenChar = false;
    }

    if (usernamePattern.test(value) && value.length >= 7) {
      this.hasNumberLettersUnderscore = false;
    } else {
      this.hasNumberLettersUnderscore = true;
    }

    if ((!usernamePatternNoSpaces.test(value) && value.length > 1) || value.length === 0) {
      this.userNamehasSpaces = true;
    } else {
      this.userNamehasSpaces = false;
    }

    if (!usernamePattern.test(value)) {
      return { invalidUsernameCharacters: true };
    }
    if (value.length > 0 && !usernamePatternNoSpaces.test(value)) {
      return { invalidUsernameCharacters: true };
    }
    return null;
  }

  validatePassword(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    const passwordPatternOneNumberCheck = /\d/;
    if (!passwordPatternOneNumberCheck.test(value)) {
      this.hasOneNumber = true;
    } else {
      this.hasOneNumber = false;
    }

    const passwordPatternOneSpecialCharCheck = /[*_!@#$%^&?]/;
    if (!passwordPatternOneSpecialCharCheck.test(value)) {
      this.hasOneSpecialCharacter = true;
    } else {
      this.hasOneSpecialCharacter = false;
    }

    if (value.length < 7 || value.length > 12) {
      this.hasLessthanSevenChar = true;
    } else {
      this.hasLessthanSevenChar = false;
    }

    const passwordPatternCharNotAllowedCheck = /[()+=\-[\]\\';,./{}|":<>~\s]/;
    if (passwordPatternCharNotAllowedCheck.test(value)) {
      this.charNotAllowed = true;
    } else {
      this.charNotAllowed = false;
    }

    const passwordPatternOneNumber = /\d/;
    if (!passwordPatternOneNumber.test(value)) {
      return { pwMeetsRequirments: true };
    }

    const passwordPatternOneLetter = /[a-zA-Z]/;
    if (!passwordPatternOneLetter.test(value)) {
      return { pwMeetsRequirments: true };
    }

    const passwordPatternCharNotAllowed = /[()+=\-[\]\\';,./{}|":<>~\s]/;
    if (passwordPatternCharNotAllowed.test(value)) {
      return { pwMeetsRequirments: true };
    }

    const passwordPatternOneSpecialChar = /[*_!@#$%^&?]/;
    if (!passwordPatternOneSpecialChar.test(value)) {
      return { pwMeetsRequirments: true };
    }
    return null;
  }

  validateConfirmPassword(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    const passwordPatternOneNumber = /\d/;
    if (!passwordPatternOneNumber.test(value)) {
      return { confirmPwMeetsRequirments: true };
    }

    const passwordPatternOneLetter = /[a-zA-Z]/;
    if (!passwordPatternOneLetter.test(value)) {
      return { confirmPwMeetsRequirments: true };
    }

    const passwordPatternCharNotAllowed = /[()+=\-[\]\\';,./{}|":<>~\s]/;
    if (passwordPatternCharNotAllowed.test(value)) {
      return { confirmPwMeetsRequirments: true };
    }

    const passwordPatternOneSpecialChar = /[*_!@#$%^&?]/;
    if (!passwordPatternOneSpecialChar.test(value)) {
      return { confirmPwMeetsRequirments: true };
    }

    return null;
  }

  validateTermsConditions(): void {
    if (!this.registerAccountForm.value.termsConditionsChkbox) {
      const termsCond = this.registerAccountForm.get('termsConditionsChkbox');
      if (termsCond) {
        termsCond.setErrors({ termsConditionsError: true });
      }
    }
  }

  onSubmit(): void {
    this.apiError = '';
    this.formErrorMessage = '';
    this.validateTermsConditions();
    if (this.emailFormData.formGroup.valid && this.registerAccountForm.valid) {
      this.utils.showSpinner();
      const registerAccountCredentialsReq = new RegisterAccountCredentials();
      registerAccountCredentialsReq.AccountId = this.accountNumber;
      registerAccountCredentialsReq.Password = this.registerAccountForm.value.password;
      registerAccountCredentialsReq.Username = this.registerAccountForm.value.username;
      registerAccountCredentialsReq.EmailId = this.emailFormData.formGroup.value.email;
      registerAccountCredentialsReq.CustomerClass = this.customerClass;
      this.apiErrors = this.storage.getSession(StorageEnum.GlobalVars).apiErrors;
      this.genericError = this.storage.getSession(StorageEnum.GlobalVars)?.genericApiError;
      this.auth.registerAccountCredentials(registerAccountCredentialsReq).subscribe({
        error: (e) => {
          const errorCode = e.message;
          const newApiError = this.apiErrors.find((error) => {
            return error.apiError.errorCode === errorCode;
          });
          if (newApiError === undefined) {
            const genericApiError = this.genericError.subheaderText;
            this.showAPIErrorLabel(genericApiError);
          } else {
            this.showAPIErrorLabel(newApiError.apiError.displayMessage);
          }
          this.utils.hideSpinner();
        },
        next: (data: any) => {
          // register credentials
          void this.router.navigateByUrl(
            Nav.Login + '?newPasswordCreated=true&userName=' + registerAccountCredentialsReq.Username,
          );
        },
      });
    } else {
      // const errorMessage = this.storage.getSession(StorageEnum.GlobalVars).formError;
      this.emailFormData.formGroup.markAllAsTouched();
      this.registerAccountForm.markAllAsTouched();
      this.showFormErrorLabel();
      this.utils.hideSpinner();
    }
  }

  confirmPasswordMatch(): void {
    const password = this.registerAccountForm.get('password');
    const confirmedPassword = this.registerAccountForm.get('confirmPassword');
    if (password && confirmedPassword) {
      const passwordValue = this.registerAccountForm.get('password')?.value;
      const confirmPasswordValue = this.registerAccountForm.get('confirmPassword')?.value;
      if (passwordValue === confirmPasswordValue && passwordValue.length > 0 && confirmPasswordValue.length > 0) {
        confirmedPassword.setErrors(null);
      } else if (passwordValue.length > 0 && confirmPasswordValue.length > 0) {
        if (passwordValue !== confirmPasswordValue) {
          confirmedPassword.setErrors({ passwords2DontMatch: true });
        }
      }
    }
  }

  togglePasswordVisibility(): void {
    this.passwordVisible = !this.passwordVisible;
  }

  toggleConfirmPasswordVisibility(): void {
    this.confirmPasswordVisible = !this.confirmPasswordVisible;
  }

  showFormErrorLabel(): void {
    this.formErrorMessage = this.storage.getSession(StorageEnum.GlobalVars).formError;
    if (this.formErrorMessage !== '') {
      this.notifi.clearAllNotifications(this.pageName);
      this.notifi.addNotification(this.formErrorMessage, NotificationType.Error, this.pageName);
    }
  }

  logDebug(data: any): void {
    this.utils.consoleGroup('Login icon-list Debug Data', data);
  }

  async goToLogin(): Promise<void> {
    await this.router.navigateByUrl(Nav.Login);
  }

  getAccountNumberAndCustomerClass(): void {
    const queryParams = this.route.snapshot.queryParams;
    const accountNumber = queryParams['accountNumber'];
    const customerClass = queryParams['customerClass'];
    this.accountNumber = accountNumber;
    this.customerClass = customerClass;
  }

  showAPIErrorLabel(errMsg: string): void {
    this.apiError = errMsg;
    if (this.apiError !== '') {
      this.notifi.clearAllNotifications(this.pageName);
      this.notifi.addNotification(this.apiError, NotificationType.Error, this.pageName);
    }
  }
}
